import { dungApiThat, goiApi } from '../api/http';
import { MOCK_CHATBOTS } from '../../mock/fixtures';
import type { ChatbotDisplay } from '../../modules/dashboard/types';
import { mockRequest } from '../../mock/transport';

/**
 * Truy cập dữ liệu chatbot.
 *
 * Khi `dungApiThat()`: gọi `GET /api/v1/m/tro-ly-ai/chatbots`.
 * Khi `?mock=`: dùng mock data để soát bốn trạng thái UI.
 */
export const chatbotRepository = {
  list: (): Promise<ChatbotDisplay[]> => {
    if (!dungApiThat()) return mockRequest(MOCK_CHATBOTS, []);
    return goiApi<ChatbotDisplay[]>('/api/v1/m/tro-ly-ai/chatbots', { query: { quan_tri: 'true' } });
  },
};
